export default "__VITE_PUBLIC_ASSET__3b9fcd46__"